import * as clipboard from "clipboard-polyfill";
export default {
  data() {
    return {};
  },
  methods: {
    //一键复制
    copyMyFunc(text) {
      try {
        var oInput = document.createElement("input");
        oInput.value = text;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        oInput.className = "oInput";
        oInput.style.display = "none";
      } catch (e) {
        console.log(e);
      }
    },
    //一键复制调用方法
    copyEventFunc(text) {
      clipboard.writeText(text).then(
        () => {
          console.log("success");
        },
        e => {
          console.log("error");
          this.copyMyFunc(text);
          console.log(e);
        }
      );
    }
  }
};
